import { Radio } from "antd";
import React from "react";

interface PredictionViewInputProps {
    value?: string;
    onChange?: (value: string) => void;
    disabled?: boolean;
}

export const PredictionViewInput: React.FC<PredictionViewInputProps> = (props) => {
    const { value, onChange, disabled = false } = props;

    const handleChange = (e: any) => {
        if (onChange) {
            onChange(e.target.value);
        }
    };

    return (
        <Radio.Group value={value} onChange={handleChange} disabled={disabled} size="middle">
            <Radio.Button value="predict">Predict</Radio.Button>
            <Radio.Button value="non-predict">Non-predict</Radio.Button>
        </Radio.Group>
    );
};
